import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  DialogActions,
  Slide
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import WarningIcon from '@material-ui/icons/Warning'
import { useStyles } from './Styles'
import { FormLoader } from '../../../../Loader/FormLoader'
import { useKeycloak } from '@react-keycloak/web'
import UserServices from '../../../../../Services/Consumers/UserServices'

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const DeleteCompany = ({
  index, data, setData, setCount, handleNotificationCall,
  handleDeleteCompanyDialog, viewDeleteCompanyDialog, openDeleteCompanyDialog
}) => {
  const classes = useStyles()
  const { keycloak } = useKeycloak()
  const intl = useIntl()
  const [deleteLoading, setDeleteLoading] = React.useState(false)

  const handleDelete = () => {
    if (!keycloak?.authenticated) return
    setDeleteLoading(true)
    UserServices.deleteCompany(
      data[index].id,
      { headers: { Authorization: `Bearer ${keycloak?.token ?? ''}` } },
      setDeleteLoading
    ).then((result) => {
      if (!result || result.status !== 200) {
        setDeleteLoading(false)
      } else {
        handleNotificationCall({
          type: 'defence',
          message: intl.formatMessage({ id: 'Companies.SuccessDelete' }),
          color: 'success'
        }, 'success')
        setData(prev => prev.filter((_, i) => i !== index))
        setCount(prev => prev - 1)
        handleDeleteCompanyDialog()
      }
    }).catch(() => {
      setDeleteLoading(false)
      handleDeleteCompanyDialog()
    })
  }

  return (
    <>
      {!!viewDeleteCompanyDialog &&
      <Dialog
        keepMounted
        fullWidth
        maxWidth={'sm'}
        open={openDeleteCompanyDialog}
        classes={{ paper: classes.NewOrderDialogPaper }}
        TransitionComponent={Transition}
        onClose={handleDeleteCompanyDialog}
        aria-labelledby="DeleteCompanyDialog"
        aria-describedby="DeleteCompanyDialog"
      >
        <IconButton
          edge={false}
          className={classes.NewOrderDialogClose}
          color="inherit"
          aria-label="close dialog"
          onClick={handleDeleteCompanyDialog}
        >
          <CloseIcon/>
        </IconButton>
        <DialogContent className={classes.NewOrderDialogContent}>
          {!!deleteLoading && <FormLoader loading={true}/>}
          <Box px={4} pt={4} pb={1} className={classes.DeleteOrderWrapper}>
            <WarningIcon className={classes.DeleteWarningIcon}/>
            <p><FormattedMessage id='Companies.DeleteConfirmation' values={{ name: data[index]?.taxpayer_name || '' }}/></p>
          </Box>
        </DialogContent>
        <DialogActions className={classes.NewOrderDialogFooter}>
          <Button size="large" variant="contained" color="primary" className={classes.DeleteOrderBtn}
                  onClick={handleDelete}>
            <FormattedMessage id='Page.Action.Delete'/>
          </Button>
          <Button onClick={handleDeleteCompanyDialog} color="primary">
            <FormattedMessage id='ChangePhone.DialogActions.cancel'/>
          </Button>
        </DialogActions>
      </Dialog>
      }
    </>
  )
}

export default DeleteCompany
